// extracted by mini-css-extract-plugin
export default {"page":"styles_page__qRzT2","hero":"styles_hero__31FTX","logo":"styles_logo__pLzQn","title":"styles_title__VDxF1","subtitle":"styles_subtitle__dXipb","hint":"styles_hint__HaMd3"};